import React from 'react';
import PropTypes from 'prop-types';
import { SkuButtonFlowListener, SkuDetailFlowButtons } from './SkuDetailFlowButtons';
import { SkuParamListener } from '../../domain/models/SkuDetail';
import { AnimationTypeValues, getAnimationClass } from '../../presentation/constants/AnimationType';
import { RequestParam } from '../../domain/models/RequestParam';
export const SkuSelectAmountWithDetail = ({
  nameParam,
  amounts,
  buttonFlowListener,
  skuParamListener,
  animationType
}) => {
  return (
    <div className={getAnimationClass(animationType)}>
      <div className="d-flex flex-row flex-wrap align-items-center justify-content-center m-4">
        <div className='cards-container'>
          {
            amounts.map((a, index) => {
              return (
                <div class="card-amount-detail" key={index} onClick={() => {
                  buttonFlowListener?.onContinuePressed(new RequestParam(nameParam, `${a.amount}`, 'Monto', false, a.subprod));
                }}>
                  <div class="amount">&#36;{a.amount}</div>
                  <div class="description"><span><i className="fas fa-info-circle"></i> </span>{a.detail}&nbsp;</div>
                </div>
              );
            })
          }
        </div>
      </div>
      <div className="mt-4">
        <SkuDetailFlowButtons listener={
          new SkuButtonFlowListener({
            onBackPressed: buttonFlowListener?.onBackPressed,
            onContinuePressed: undefined
          })
        } />
      </div>
    </div>
  )
}

SkuSelectAmountWithDetail.propTypes = {
  nameParam: PropTypes.string.isRequired,
  amounts: PropTypes.arrayOf(PropTypes.object).isRequired,
  buttonFlowListener: PropTypes.instanceOf(SkuButtonFlowListener),
  skuParamListener: PropTypes.instanceOf(SkuParamListener),
  animationType: PropTypes.oneOf(AnimationTypeValues)
}
